import React, { useEffect, useState, useCallback} from "react";

import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Spinner, Container, Row, Col } from "react-bootstrap";
import { STUDENT_SIDEBAR_LOCK_API } from "../../api/api";

const StudentRouteGuard = ({ children, accessField }) => {
  const navigate = useNavigate();
  const [accessData, setAccessData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchAccess = useCallback(async () => {
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      setAccessData(null);
      setLoading(false);
      navigate("/signin", { replace: true });
      return;
    }

    try {
      const res = await axios.post(
        STUDENT_SIDEBAR_LOCK_API.STUDENT_DASHBOARD_LOCK,
        { student_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data?.statusCode === 200) {
        setAccessData(res.data.data || {});
      } else {
        setAccessData(null);
      }
    } catch (error) {
      console.error("Access check failed:", error);
      setAccessData(null);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchAccess();
  }, [fetchAccess, location.pathname]); // runs on route change

  // Loading UI
  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <Row>
          <Col className="text-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        </Row>
      </Container>
    );
  }

  // If locked → redirect
  if (!accessData?.[accessField]) {
    return <Navigate to="/student/courses" replace />;
  }

  // If allowed → show page
  return children;
};

export default StudentRouteGuard;
